import { render, staticRenderFns } from "./importArea.vue?vue&type=template&id=660642e3&scoped=true"
import script from "./importArea.vue?vue&type=script&lang=js"
export * from "./importArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660642e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('660642e3')) {
      api.createRecord('660642e3', component.options)
    } else {
      api.reload('660642e3', component.options)
    }
    module.hot.accept("./importArea.vue?vue&type=template&id=660642e3&scoped=true", function () {
      api.rerender('660642e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/basicData/districtManagement/cmp/importArea.vue"
export default component.exports